module.exports = __webpack_public_path__ + "img/icon_ov_bg.f0ed7431.png";